var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_491_324)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.523438 18.7144L7.84898 13.9261L12.1067 20.6002L15.7741 13.6283L22.324 18.1276L22.8127 9.98633L31.3477 10.5286",
    stroke: "#005BFF",
    strokeWidth: 1.26023
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.18388 10.4035L7.6619 6.23142C7.8023 6.10061 7.97279 6.00697 8.15804 5.95887M3.18388 10.4035L7.55115 13.4915C7.76155 13.6402 8.01526 13.7141 8.27208 13.7013M3.18388 10.4035L0.708414 17.8393C0.534148 18.3627 0.749717 18.9373 1.22423 19.2142L18.9059 29.5314C19.4526 29.8505 20.1526 29.6679 20.4766 29.1218L31.0884 11.2353C31.3743 10.7534 31.2774 10.1349 30.8581 9.76502L25.209 4.78315M3.18388 10.4035L8.15804 5.95887M3.18388 10.4035L8.27208 13.7013M8.15804 5.95887L18.7139 3.21943C18.9046 3.16992 19.1048 3.17036 19.2954 3.22071M8.15804 5.95887L19.2954 3.22071M19.2954 3.22071L25.209 4.78315M25.209 4.78315L22.7434 9.49132M8.27208 13.7013L15.4623 13.343C15.6248 13.3349 15.7837 13.2924 15.9286 13.2182M8.27208 13.7013L15.9286 13.2182M15.9286 13.2182L22.2452 9.98542C22.4579 9.87651 22.6319 9.70388 22.7434 9.49132M15.9286 13.2182L22.7434 9.49132",
    stroke: "#005BFF",
    strokeWidth: 1.26023
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.585938 18.6751L12.1397 21.2385L22.4885 18.4699L31.3292 10.5654",
    stroke: "#005BFF",
    strokeWidth: 1.26023
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1406 21.2411L19.7026 29.3759C19.755 29.4321 19.8485 29.4074 19.8665 29.3325L22.4899 18.4688",
    stroke: "#005BFF",
    strokeWidth: 1.26023
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_491_324"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 28,
    fill: "white",
    transform: "translate(0 2.40039)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/Diamond.6c4cfbcee2d1b016ad9e042bc0a1d7ad.svg";
export { ForwardRef as ReactComponent };